import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {Component} from "@angular/core";
import {AbstractFooterModalView} from "../../../views/AbstractFooterModalView";

@Component({
  selector: 'link-modal-footer',
  templateUrl: './modal-footer.view.html',
  styleUrls: ['./modal-footer.view.scss']
})
export class ModalFooterView extends AbstractFooterModalView {

  constructor(dialogService: DialogService,
              dialogRef: DynamicDialogRef) {
    super(dialogService, dialogRef);
  }

  onActionClicked(actionName: string) {
    this.getController().handle(actionName, {});
  }
}
